// MUI
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

export const StaffInfo = ({ staffInfo }) => {
  return (
    <Card sx={{ minWidth: 200 }}>
      <CardContent>
        <Typography sx={{ mb: 1.5 }}>Name: {staffInfo.staff.name}</Typography>
        <Typography sx={{ mb: 1.5 }}>ID: {staffInfo.staff.yourid}</Typography>
        <Typography sx={{ mb: 1.5 }}>
          Wardrobe: {staffInfo.staff.uniformName}
        </Typography>
        <Typography sx={{ mb: 1.5 }}>
          Branch: {staffInfo.staff.branchName}
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary", mb: 1.5 }}>
          If you believe this information is incorrect, please contact your line
          manager.
        </Typography>
      </CardContent>
    </Card>
  );
};
